import CheckOnboarding from './CheckOnboarding';
export default CheckOnboarding;